import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('prednex-lang');
    if (saved) return saved;
    // Auto-detect from browser
    const browserLang = navigator.language?.slice(0, 2);
    return browserLang === 'bg' ? 'bg' : 'en';
  });

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => {
      const next = prev === 'bg' ? 'en' : 'bg';
      localStorage.setItem('prednex-lang', next);
      return next;
    });
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLang must be used within LanguageProvider');
  return context;
}
